export default {
    props: {
        positionBottom: {
            type: Number,
            default: undefined,
            kComposite: 'position.bottom'
        }, 
        positionLeft: {
            type: Number,
            default: undefined,
            kComposite: 'position.left'
        }, 
        positionPinned: {
            type: Boolean,
            default: undefined,
            kComposite: 'position.pinned'
        }, 
        positionRight: {
            type: Number,
            default: undefined,
            kComposite: 'position.right'
        }, 
        positionTop: {
            type: Number,
            default: undefined,
            kComposite: 'position.top'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/Position.js